import React from 'react';
import styled from 'styled-components';
import CustomMask from './CustomMask';
import './Preview360.CSS';

const CustomContainer = styled.div`
  opacity: 0;
  color: white;
  transition: opacity 0.3s;
  cursor: pointer;
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  justify-content: center;
  align-content: center;
  align-items: center;

  &:hover {
    opacity: 1;
    background: rgb(0, 0, 0, 0.5);
  }
`;
const Preview360 = ({ children }) => {
  return (
    <>
      {children}
      <CustomContainer id="preview360">
        <CustomMask />
      </CustomContainer>
    </>
  );
};

export default Preview360;
